import "./Account.css";
import { useContext, useEffect, useState, useRef, } from "react";
// import Button from "@mui/material/Button";
import { AppRegistration, Login, Logout, Refresh } from "@mui/icons-material";
import { motion, useAnimationControls } from "framer-motion";

import AppContext from "../contexts/AppContext";
import { format } from "date-fns";
import CookieContext from "../contexts/CookieContext";
import ExpTimeContext from "../contexts/ExpTimeContext";
import axios from "axios";
import { useForm } from "react-hook-form";
import { styled } from '@mui/material/styles';
import Paper from '@mui/material/Paper';

// Dialog関連
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, } from '@mui/material';

const Item = styled(Paper)(({ theme }) => ({
  overflowWrap: 'break-word',
  backgroundColor: '#e9dfdf',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  // textAlign: 'center',
  textAlign: 'left',
  color: theme.palette.text.secondary,
  ...theme.applyStyles('dark', {
    backgroundColor: '#1A2027',
  }),
}));

const Device = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    getValues,
  } = useForm({ mode: "onChange" });

  const { apiHost, AppButton } = useContext(AppContext);

  const { cookies, setJwtCookies, refreshJwtCookies, removeJwtCookies } =
    useContext(CookieContext);

  const alertAnimationControls = useAnimationControls();

  const [axiosErr, setAxiosErr] = useState({ code: "", msg: "" });
  const { leftTime, leftTimeMs, leftTimeDhms } = useContext(ExpTimeContext);

  const [elevation, setElevation] = useState('6');

  // dayOfWeek[] 0:日曜日、1:月曜日、2:火曜日、3:水曜日、4:木曜日、5:金曜日、6:土曜日
  const dayOfWeek = Object.freeze({
    0: "日",
    1: "月",
    2: "火",
    3: "水",
    4: "木",
    5: "金",
    6: "土",
  });

  // Date().getDay() 0:日曜日、1:月曜日、2:火曜日、3:水曜日、4:木曜日、5:金曜日、6:土曜日
  const day = new Date().getDay();
  // youbi:和名
  const youbi = dayOfWeek[day];
  const [clock, setClock] = useState("0000/00/00(　) 00:00:00");

  // ボタンの有効化/無効化の管理
  const [disabled, setDisabled] = useState(false);

  const time = () => {
    // 出力フォーマット
    const curTime = format(Date.now(), "yyyy/MM/dd(" + youbi + ") HH:mm:ss");
    setClock(curTime);

    if (leftTime(cookies.refreshTokenExp) > 0) {
    } else if (leftTime(cookies.refreshTokenExp) === "-") {
      // 残り時間が "-" でなく、cookieにjwtAccessがあれば、このタイミングで期限が切れたことを意味するので、cookieを削除し、ゲスト画面に戻す
      if (cookies.jwtAccess) {
        // cookieを削除し、ログイン画面を表示
        removeJwtCookies();
        // ログアウト時と同じ動作、MyPageへ遷移
        (window.location.href = "/");
      }
    } else {
    }
  };

  let ClockClassName = "ClockNormal";

  if (day === 0) {
    // 日曜日は赤色表示
    ClockClassName = "ClockSun";
  } else if (day === 6) {
    // 土曜日は青色表示
    ClockClassName = "ClockSat";
  } else {
    // 平日は色変化なし
  }

  // メッセージボックス
  const [messageBoxOpen, setMessageBoxOpen] = useState(false);
  const [messageBoxTitle, setMessageBoxTitle] = useState('');
  const [messageBoxMessage, setMessageBoxMessage] = useState('');

  const handleMessageBoxOpen = (title, message) => {
    setMessageBoxTitle(title);
    setMessageBoxMessage(message);
    setMessageBoxOpen(true);
  }
  const handleMessageBoxClose = () => {
    setMessageBoxOpen(false);
    (window.location.href = "/");
  }

  const onRegister = async (data) => {

    // ボタンを無効化
    setDisabled(true);
    try {
      const res = await axios
        .post(
          // `https://api2.wacha.biz/device/register/`,
          `${apiHost}device/register/`,
          {
            // uuid: data.uuid,
            // password: data.password,
          },
          {
            headers: { "Content-Type": "application/json" },
          }
        )

      // resに格納されたJSONデータをパラメータで引継ぎ
      onLogin(res.data);
    } catch (e) {
    } finally {
    }
  }

  const onLogin = async (data) => {

    // alert(data.uuid)
 
    // ボタンを無効化
    setDisabled(true);
    // alert(cookies.accessTokenUuid)
    // alert(cookies.accessTokenManagementCd)
    await axios
      .post(
        // `https://api2.wacha.biz/device/token/`,
        `${apiHost}device/token/`,
        {
          uuid: data.uuid,
          password: data.management_cd,
        },
        {
          headers: { "Content-Type": "application/json" },
        }
      )
      .then((res) => {
        setDisabled(false);
        setJwtCookies(res.data.access, res.data.refresh);

        // ログイン成功時
        if (res.status === 200) {
          handleMessageBoxOpen('ログイン', 'ログインしました');
        } else {
          handleMessageBoxOpen('エラー', 'DeviceUuidまたはManagementCdが違います');
        }
      })
      .catch((err) => {
        setDisabled(false);
        if (err.response && err.response.status === 400) {
          handleMessageBoxOpen('エラー', 'DeviceUuidまたはManagementCdが違います');

          // client received an error response (5xx, 4xx)
          console.log("err.response:", err.response);
          console.log("err.response.status:", err.response.status);
          console.log("err.response.data.detail:", err.response.data.detail);

          setAxiosErr({
            ...axiosErr,
            code: err.response.status,
            msg: "ユーザ名またはパスワードが違います",
          });
        } else if (err.request) {
          // client never received a response, or request never left
          console.log("err.request:", err.request);

          setAxiosErr({
            ...axiosErr,
            code: "",
            msg: "エラーが発生しました",
          });
        } else {
          // anything else
          console.log("err:", err);

          setAxiosErr({
            ...axiosErr,
            code: "",
            msg: "エラーが発生しました",
          });
        }
      })
      .finally(() => {
        // ログイン後はHomeへ遷移
        (window.location.href = "/");
      });
  };

  const onClearUuid = async () => {
    removeJwtCookies();
    // ログアウト後はHomeへ遷移
    (window.location.href = "/");
  }


  useEffect(() => {
    const interval = setInterval(time, 200);
    return () => {
      clearInterval(interval);
    };
  });

  // 曜日によって色を変更する時計（平日：翠、土曜：青、日曜：赤）
  const clockInfo = () => {
    return (
      <>
        <div className={ClockClassName} style={{ margin: "5px", fontWeight: 700, }}>
          {clock}
        </div>
      </>
    )
  }

  // jwtAccessの有無によって表示内容を変更
  const returnIfJwtAccessOrNot = () => {
    if (cookies.jwtAccess) {
      return (
        <>
          <Item elevation={elevation}><b>jwtAccess&nbsp;:&nbsp;</b>{cookies.jwtAccess ? cookies.jwtAccess : "xxxxxxxxxxxx"}</Item>
          <div style={{ margin: "5px", fontWeight: 700, }}>
            <p id="uuid">
            {cookies.accessTokenDeviceUuid}
            </p>
            <p id="uuidLists">
            {cookies.uuidLists}
            {/* {JSON.parse(cookies.uuidList)} */}
            </p>
            <form onSubmit={handleSubmit(onClearUuid)}>
            <AppButton disabled={disabled}>
              <span>わちゃをクリア</span>
            </AppButton>
            </form>
           </div>

            <div style={{ margin: "5px" }}>
            {/* 1日 = 60秒 × 60分 × 24時間 = 86,400秒 */}
            {/* 100日 = 86,400 × 100 = 8,640,000 100日前から更新可能にするには、8,640,000 */}
            {/* 30日 = 86,400 × 30 = 2,592,000 30日前から更新可能にするには、2,592,000 */}
            {/* {leftTime(cookies.refreshTokenExp) < 8639970 ? ( */}
            {leftTime(cookies.refreshTokenExp) < 2592000 ? (
            // {leftTime(cookies.refreshTokenExp) < 8640000 ? (
              <AppButton
                className="refreshTokenExp"
                disabled={disabled}
                variant="contained"
                color="warning"
                endIcon={<Refresh />}
                onClick={refreshJwtCookies}
              >
                <span className="material-symbols-outlined">
                  ログイン継続（{leftTimeDhms(cookies.refreshTokenExp)}）
                </span>
              </AppButton>
            ) : (
              "認証期限：" + cookies.refreshTokenExpTime + "まで"
            )}
          </div>
        </>
      )
    }
    else {
      return (
        <>
          <div style={{ display: "flex", justifyContent: "center", margin: "5px", fontWeight: 700, }}>
            <Item elevation={elevation}>
              <form onSubmit={handleSubmit(onRegister)}>
                <AppButton disabled={disabled}>
                  <span>わちゃidを作成</span>
                </AppButton>
              </form>
            </Item>
            {/* <form onSubmit={handleSubmit(onDeviceLogin('d25bea1f6ff74eb98624d09c86a5facc', 'ziZ1Mkoek8EJEHJoLoDJVFE2dFfaxfDs'))}> */}
            <Item elevation={elevation}>
              <form onSubmit={handleSubmit(onLogin)}>
                <input style={{ margin: "5px", fontSize: 30, }} {...register("uuid")} /><br />
                <input style={{ margin: "5px", fontSize: 30, }} {...register('management_cd')} />
                <AppButton disabled={disabled}>
                  <span>ログイン</span>
                </AppButton>
              </form>
            </Item>
          </div>
        </>
      )
    }
  }

  return (
    <>
      {clockInfo()}
      {returnIfJwtAccessOrNot()}
      <div style={{ margin: "5px", fontSize: 700, }}>
        <Item elevation={elevation}><b>cookies.accessTokenUuid&nbsp;:&nbsp;</b>{cookies.accessTokenUuid}</Item>
        <Item elevation={elevation}><b>cookies.accessTokenManagementCd&nbsp;:&nbsp;</b>{cookies.accessTokenManagementCd}</Item>
      </div>
      <Dialog
        aria-modal='true'
        open={messageBoxOpen}
        onClose={handleMessageBoxClose}
        aria-labelledby="messageBox-dialog-title"
        aria-describedby="messageBox-dialog-description"
      >
        <DialogTitle sx={{m:0, p:2}} id="messageBox-dialog-title">
          【{messageBoxTitle}】
        </DialogTitle>
        <DialogContent dividers>
          <DialogContentText id="alert-dialog-description">
            {messageBoxMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <AppButton id='messagebox' onClick={handleMessageBoxClose} autoFocus>OK</AppButton>
        </DialogActions>
      </Dialog>
    </>
  )
}
export default Device
